import React from 'react';

const AboutNutritionSection = () => {
  return (
    <div
      className="pt-80 pb-80"
      style={{
        background: 'linear-gradient(to right, #fff1c6, #cccccc, #dac587, #f2fded)',
        backgroundSize: '200% 200%',
        animation: 'gradientBackground 15s ease infinite',
        width: '100%',  
        overflow: 'hidden',  
      }}
    >
      <div className="grid grid-cols-12 ">
        <div className="col-span-12 md:col-span-8 custom-padding-about xl-screen-padding-about ">
          <h1 className="text-4xl text-black mb-6 font-merriweather  ">
            <span className="text-black">Transform Your Life-</span>
            <span className="text-[#8f762c]">Tailored Nutrition</span>
            <span className="text-black"> for Every Goal</span>
          </h1>
          <p className="text-[#909491] mb-8 text-p">
            We are here to enhance your personalized nutrition plan, ensuring that everyone can
            benefit, regardless of their health, fitness, or wellness goals.
          </p>

          <ul className="list-disc list-inside text-[#909491] text-left space-y-4 text-p">
            <li>
              Individuals who prioritize preventive healthcare and seek nutrition tailored to their
              unique genetics
            </li>
            <li>People looking for a sustainable approach to weight loss.</li>
            <li>Those managing digestive issues or aiming to improve overall well-being.</li>
            <li>
              Recreational and competitive athletes optimizing nutrition for better performance
              and recovery.
            </li>
            <li>
              Individuals struggling with diabetes or hormonal imbalances and seeking lasting
              health solutions.
            </li>
            <li>
              Mothers-to-be who want a nourishing diet for a healthy pregnancy and a strong,
              healthy baby.
            </li>
          </ul>
        </div>
        <div className="col-span-12 md:col-span-4 flex items-center justify-end relative">
          <div className="flex items-center justify-center ">
            <div
              className="absolute top-0 bottom-0 w-3/4 bg-white rounded-l-full mobile-height transformimg"
            ></div>
            <div className="tailoredimg overflow-hidden z-10 custom-translate" >
              <img
                src={require('../../src/assets/images/diet1.png')}
                alt="Appointment"
                className="object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutNutritionSection;
